class Queue {
  constructor() {
    this.storage = [];
  }
  enqueue(item) {
    this.storage.push(item);
  }
  dequeue() {
    return this.storage.shift();
  }
  peek() {
    return this.storage[0];
  }
  size() {
    return this.storage.length;
  }
}
export function createQueue() {
  return new Queue();
}